<template>
  <div :class="['home flex-column', programStyle]">
    <div class="title-container flex-row">
      <div class="flex-column">
        <span class="title">{{ $t('profile') }}</span>
        <ul class="subtitle flex-row">
          <li @click="goToDashboard">Dashboard&nbsp;&gt;&nbsp;</li>
          <li @click="goToDashboard">{{ domain }}&nbsp;&gt;&nbsp;</li>
          <li @click="editUser = false">Profile</li>
          <li v-if="editUser">&nbsp;&gt;&nbsp;Edit</li>
        </ul>
      </div>
    </div>
    <div class="content flex-column">
      <span>{{ $t('your-information') }}</span>
      <p>{{ $t('contact-information') }}</p>
      <div v-if="editUser" class="edit-user-details">
        <ul v-if="user" class="flex-column">
          <li>
            <input type="text" placeholder="First Name" v-model="user.firstName" />
            <input type="text" placeholder="Last Name" v-model="user.lastName" />
          </li>
          <li>
            <input type="text" placeholder="Email" v-model="user.email" /><input
              type="text"
              placeholder="Phone Number"
            />
          </li>
          <li>
            <Multiselect
              v-model="user.defaultLanguage"
              :options="languageOptions"
              class="multiselect single"
              :placeholder="$t('default-language')"
              :showLabels="false"
              :allow-empty="false"
            ></Multiselect>
          </li>
        </ul>
      </div>
      <div v-else class="user-details flex-row">
        <div class="details">
          <ul v-if="user">
            <li>
              <span>{{ $t('name') }}:</span> {{ user.firstName }} {{ user.lastName }}
            </li>
            <li>
              <span>{{ $t('phone-number') }}:</span>
            </li>
            <li>
              <span>{{ $t('email') }}:</span> {{ user.email }}
            </li>
            <li>
              <span>{{ $t('default-language') }}:</span> {{ user.defaultLanguage }}
            </li>
          </ul>
        </div>
        <div class="current-roles">
          <ul v-if="user">
            <li><span>SID:</span> {{ user.uid }}</li>
            <li>
              <span>{{ $t('role') }}(s): </span>
              <span id="role-name" v-for="role in user.roles" :key="role.roleId"
                >{{ role.role }}<span class="role-comma">, </span></span
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="button-container flex-row">
        <button
          v-if="editUser"
          :class="['add', editValidation ? '' : 'disabled']"
          :disabled="!editValidation"
          @click="editProfileDetails"
        >
          {{ $t('save') }}
        </button>
        <button v-if="!editUser" @click="editUser = true">{{ $t('edit') }}</button>
        <button v-if="editUser" @click="editUser = false">{{ $t('cancel') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Multiselect from 'vue-multiselect';

export default {
  name: 'Profile',
  components: { Multiselect },
  data() {
    return {
      user: null,
      currentRoles: [],
      editUser: false,
      languageOptions: [],
      updateLang: null,
      isLanguageUpdated: false,
    };
  },
  methods: {
    ...mapActions(['updateLanguage']),
    getProfileDetails() {
      const loader = this.$loading.show();

      const { domain } = this;

      this.$store
        .dispatch('getProfileDetails', {
          domain,
        })
        .then((res) => {
          this.user = res.data.curUserDetails;
          this.currentRoles = res.data.curUserDetails.roles;
          this.setDefaultLanguage(res.data.curUserDetails.defaultLanguage);
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    setDefaultLanguage(language) {
      if (language === 'EN' || language === 'English') {
        this.user.defaultLanguage = 'English';
      } else {
        this.user.defaultLanguage = 'French';
      }
    },
    editProfileDetails() {
      const loader = this.$loading.show();

      this.editUser = true;
      const { firstName, lastName, email } = this.user;

      let { defaultLanguage } = this.user;
      if (defaultLanguage === 'English') {
        defaultLanguage = 'EN';
      } else {
        defaultLanguage = 'FR';
      }

      this.$store
        .dispatch('editProfileDetails', { firstName, lastName, email, defaultLanguage })
        .then((res) => {
          if (res) {
            this.editUser = false;
            if (this.isLanguageUpdated) {
              this.changeLanguage(defaultLanguage);
            }
          }
        })
        .catch((error) => {
          this.$notify({
            group: 'primary',
            type: 'error',
            text: error.data.error,
          });
        })
        .finally(() => {
          loader.hide();
        });
    },
    changeLanguage(defaultLanguage) {
      if (defaultLanguage === 'EN') {
        this.updateLang = { code: 'en', name: 'English' };
      } else {
        this.updateLang = { code: 'fr', name: 'French' };
      }
      this.updateLanguage(this.updateLang);
    },
    getLanguageOptions() {
      const loader = this.$loading.show();

      this.$store
        .dispatch('getLanguageOptions', {})
        .then((res) => {
          this.setLanguageOptions(res.defaultLanguageOpts);
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    setLanguageOptions(options) {
      const languages = [];
      options.forEach((option) => {
        languages.push(option.languageName);
      });
      this.languageOptions = languages;
    },
    goToDashboard() {
      this.$router.push({
        name: 'Dashboard',
      });
      this.$store.state.activeNavTab = this.activeNavBar[0];
    },
  },
  computed: {
    ...mapState('global', ['programName', 'programStyle']),
    ...mapState(['activeNavBar', 'activeNavTab']),
    ...mapState({
      domain: (state) => state.global.programName,
    }),
    editValidation() {
      if (this.user.firstName && this.user.lastName && this.user.email) {
        return true;
      }
      return false;
    },
  },
  watch: {
    editUser() {
      if (!this.editUser) {
        this.getProfileDetails();
      } else {
        this.getLanguageOptions();
      }
    },
    'user.defaultLanguage': function (newValue, oldValue) {
      if (newValue && oldValue && newValue !== oldValue) {
        this.isLanguageUpdated = true;
      }
    },
  },
  created() {
    this.getProfileDetails();
  },
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  .title {
    font-size: 32px;
    font-weight: 100;
    text-transform: uppercase;
  }
  .subtitle {
    font-size: 14px;
    margin-top: 5px;
    list-style-type: none;
    margin-bottom: 0px;
    padding-left: 0px;
    li {
      cursor: pointer;
    }
    li:last-child {
      cursor: default;
      font-weight: bold;
    }
  }
}
.content {
  height: 100%;
  padding-left: 47px;
  flex-wrap: wrap;
  text-align: left;
  padding-top: 34px;
  ul {
    list-style-type: none;
    padding-left: 0px;
  }
  .button-container {
    button {
      margin-right: 20px;
    }
  }
}
.title-container {
  text-align: left;
  border-bottom: 1px #dfe4e8 solid;
  padding-left: 40px;
  padding-bottom: 25px;
  padding: 34px 57px 24px 47px;
  justify-content: space-between;
  .right {
    display: flex;
  }
}
span {
  font-size: 21px;
}
p {
  font-size: 18px;
  color: $primary-black;
  margin: 24px 0px 0px;
}
.user-details {
  margin: 24px 0px;
}
.details {
  color: $primary-black;
  ul {
    margin-bottom: 0px;
    padding-bottom: 0px;
    margin-top: 0px;
    margin-bottom: 0px;

    li {
      margin-top: 15px;
      margin-left: 0;
      span {
        font-size: inherit;
        font-family: 'Encode Sans Expanded', sans-serif;
        font-weight: medium;
      }
    }
    li:first-child {
      margin-top: 0px !important;
    }
  }
}
.current-roles {
  color: $primary-black;
  ul {
    margin-top: 0px;
    margin-bottom: 0px;
    li {
      margin-top: 15px;
      margin-left: 0;
    }
    li:first-child {
      margin-top: 0px !important;
    }
    span {
      font-size: inherit;
      font-family: 'Encode Sans Expanded', sans-serif;
      font-weight: medium;
    }
  }
  border-left: 2px solid $fca-gray;
  margin-left: 46.5px;
  padding-left: 50.5px;
}
.edit-user-details {
  ul {
    margin: 12px 0px 12px;
  }
  li {
    margin: 12px 0px;
    display: flex;
  }
  input {
    width: 349px;
    height: 46px;
    margin-right: 15px;
  }
}
#role-name {
  font-family: 'Encode Sans', sans-serif;
}
.role-comma {
  font-weight: inherit !important;
}
#role-name:last-of-type {
  .role-comma {
    visibility: hidden;
  }
}
.multiselect {
  width: 231px !important;
}
</style>
